/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import Axios from "axios";
import store from "store";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/ducks";

import {
  TextField,
  Textarea,
  Checkbox,
  Radio,
  Select,
  Spinner,
  Option,
  Attachments,
} from "pipestyle";

import PipefyService from "services/pipefy.service";
import TicketServices from "services/ticket.service";
import DomainSettingService from "services/domainSetting.service";
import BrandServices from 'services/brand.service';
import StorageFileService from "services/storageFile.service";
import TicketRule from 'services/Ticket/rule.service';
import OrderServices from "services/order.service";

import { Row, Column } from "components/Layout/Grid";
import CloseButton from "components/CloseButton";
import toast from "components/Toast/dispatch";
import { IOption, ICategoriesReasons, IPipefyOption } from 'components/Select/interface';
import TextArea from 'components/TextArea';
import PhaseForm from "components/Pipefy/PhaseForm";
import History from "components/Pipefy/History";

import {
  cleanStr,
  fixUrls,
  getApprovalFieldId,
  getDonePhasesOnly,
  getFieldValueFromHistory,
  getStatusType,
  hideExchangeLetterPdfHistory,
  isInputDisableToPhaseApprovalForLoss,
  isLabelMinimalReadOnly,
  isLabelReadOnly,
  isManualDevolutionEnterprise,
  processResponsibleGroup,
  urlReplace
} from "utils/Pipefy";

import { DateStringPipefy } from "utils/DateOutput";
import { OrderArrayByNumberKey } from "utils/enumArray/enumHelpers";
import { RemoveAccent } from "utils/String";
import { RemoveCharsAccents } from "utils/RemoveCharsAccents";

import { ITickets } from "models/Ticket";
import { IDomainSetting } from "models/DomainSetting";
import { IRequestConfig, MethodsTypes } from "models/Axios";
import { IBatchRequestResponse } from "models/Batch";
import { IOrders } from "models/Order";
import { FileOriginType } from "models/StorageFile";

import authServices from "core/authentication/authService";
import { useHideOnClickOutside } from "hooks/useHideOnClickOutside";

import {
  CardFieldsCurrentPhaseProps,
  CardProps,
  CurrentPhaseMovedToPhasesProps,
  Field,
  FieldsCardProps,
  FieldsCurrentPhaseProps,
  phasesBuCardPipefy,
  PhasesHistoryProps,
  reasonsShowSefaz
} from "./interface";

import {
  fieldsToDisableOnQuality,
  inputsDisableToPhaseApprovalForLoss
} from "./config";

import {
  PhasesProtocols,
  PipefyFieldIdsEnum,
  PipefyFieldLabelEnum,
  EnumPipefyInputFieldIds,
  EnumDisableContext,
  ReasonNameEnum,
  CategoryNameEnum
} from "./enum";

import { ruleHidePhaseCancel } from "rules/Pipefy";
import { PipefyLinkType } from "models/User";

import { PipefyStyles, InputDate } from "./styles";

const Pipefy: React.FC<{
  cardNumber?: number;
  protocolNumber?: number;
  responsibleGroup?: string;
}> = (props) => {
  const { cardNumber, protocolNumber, responsibleGroup } = props;

  const [form, setForm] = useState<any>();
  const [pipePhases, setPipePhases] = useState<any>();
  const [state, setState] = useState<any>({});
  const [lastChangedField, setLastChangedField] = useState<any>({});
  const [adverseEventChecked, setAdverseEventChecked] = useState<string | null>(null);
  const [sentValues, setSentValues] = useState<any>({});
  const [responsibleGroupAux, setResponsibleGroupAux] = useState<string>(responsibleGroup || "");
  const [moveCard, setMoveCard] = useState(false);
  const [isMovingCard, setIsMovingCard] = useState(false);
  const [blockMoveCardAwaitUpdateField, setBlockMoveCardAwaitUpdateField] = useState(false);
  const user = useSelector((state: RootState) => state.user);
  const card = useSelector((state: RootState) => state.card);
  const dispatch = useDispatch();
  const [userProfileTypes, setUserProfileTypes] = useState(
    Array<IDomainSetting>()
  );
  const [progress, setProgress] = useState(0);
  const [allCategories, setAllCategories] = useState<Array<IPipefyOption>>([]);
  const [allReasons, setAllReasons] = useState<Array<IPipefyOption>>([]);
  const [allClassifications, setAllClassifications] = useState<Array<IPipefyOption>>([]);
  const [brandOption, setBrandOption] = useState(Array<IOption>());
  const [phasesBloquedUpdate, setPhasesBloquedUpdate] = useState(Array<string>());
  const [orderEnterpriseCode, setOrderEnterpriseCode] = useState<number | undefined>(undefined);
  const [ticketCard, setTicketCard] = useState<ITickets | undefined>(undefined);
  const [filesMap, setFilesMap] = useState<{ [key: string]: React.ReactNode[]; }>({});

  const _domainSettingService = new DomainSettingService();
  const _authServices = new authServices();
  const _ticketService = new TicketServices();
  const _brandServices = new BrandServices();
  const _storageFileService = new StorageFileService();
  const _pipefyService = new PipefyService();
  const _orderService = new OrderServices();

  const base_url = process.env.REACT_APP_API_BASE_URL;
  const access_token = _authServices.credentials()?.access_token;
  const PROTHEUS_STORAGE_NAME = "saexpedlog.blob";

  useHideOnClickOutside(setMoveCard);

  const fetchTicket = async () => {
    await _ticketService
      .get(undefined, undefined, undefined, { id: card?.ticketId })
      .then((result: any) => {
        if (result.data) {
          setTicketCard(result.data[0]);
          if (card && form.card.current_phase.name === PhasesProtocols.DESABILITAR_MOVE_PARA) {
            store.dispatch({
              type: "UPDATE_CARD",
              ticketDevolution: result.data[0].ticketDevolution || null,
            });
          }
        }
      });
  };

  useEffect(() => {
    if (!form) {
      return;
    }

    fetchTicket();
    fetchFilesUrls();
  }, [form]);

  useEffect(() => {
    const orderNumber = form?.card?.fields.find((x: FieldsCardProps) => x.name === "Nº do Pedido")?.value;

    if (!orderNumber) {
      return;
    }

    const search = { textFilter: orderNumber };

    _orderService
      .get(
        0,
        undefined,
        undefined,
        search
      )
      .then((result: IBatchRequestResponse<IOrders> | undefined) => {
        if (result?.data) {
          setOrderEnterpriseCode(result.data[0]?.enterpriseCode);
        }
      });
  }, [form]);

  useEffect(() => {
    if (form?.card && form.card.current_phase.name === PhasesProtocols.RETORNO_SAC) {
      (form.card.current_phase.fields as FieldsCurrentPhaseProps[]).map((item) => {
        mustCreditValueBeRequired(item);
      });
    }
  }, [sentValues]);

  const fetchFilesUrls = async () => {
    const newFilesMap: { [key: string]: React.ReactNode[]; } = {};

    const attachmentItems = form.card.phases_history[0]?.phase?.fields.filter(
      (item: { id: string; }) => item.id === EnumPipefyInputFieldIds.ANEXOS_SUBMETIDOS ||
        item.id === EnumPipefyInputFieldIds.ANEXO_RECLAMACAO_TECNICA
    );

    for (const item of attachmentItems) {
      const files = await downloadLink(item.id);
      newFilesMap[item.id] = files;
    }

    setFilesMap(newFilesMap);
  };

  const getForm = useCallback(
    async (reload: boolean = true) => {
      if (reload) setForm(undefined);
      await _pipefyService
        .findCard(cardNumber || 62363996)
        .then(async (result) => {
          if (result) {

            card?.state?.setRefreshTable(false);

            let responsibleGroupForm = getResponsibleGroup(result);

            if (responsibleGroupForm) setResponsibleGroupAux(responsibleGroupForm);

            await _pipefyService
              .findPipe(result.data.card.pipe.id)
              .then((pipeResult) => {
                setPipePhases(pipeResult.data.pipe.phases);
              })
              .catch(() => {
                dispatch({ type: "SET_CARD_ID", id: undefined });
              });

            hideExchangeLetterPdf(result.data.card);

            setForm(result.data);

            const state: any = {};

            result.data.card.current_phase.fields.map((field: any) => {

              if (field.id === "id_da_solicita_o") {
                // eslint-disable-next-line no-return-assign
                state.id_da_solicita_o = cardNumber;
                return state.id_da_solicita_o;
              }

              const formField = result.data.card.fields.find(
                (item: any) => item.field.id === field.id
              );

              if (field.type === 'date') {
                if (formField && formField.value && formField.value !== '') {
                  if (/\d{2}\/\d{2}\/\d{4}/.test(formField.value)) {
                    const dateSplit = formField.value.split('/');
                    const dateFormatted = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;

                    state[field.id] = dateFormatted;
                    return state[field.id];
                  }

                  state[field.id] = DateStringPipefy(formField.value);
                  return state[field.id];
                }
              }

              state[field.id] = cleanStr(formField?.value);

              return;
            });
            setState(state);
            setSentValues({ ...state });
          }
        })
        .catch((ex) => {
          console.error('Erro durante findCard', ex.message);
          dispatch({ type: "SET_CARD_ID", id: undefined });
        });
    },
    [cardNumber]
  );

  const hideExchangeLetterPdf = (data: CardProps) => {
    if (card?.ticketReason !== 'CARTA DE TROCA') {
      return;
    }

    const indexOf = data.current_phase.fields.map(
      (item: FieldsCurrentPhaseProps) => item.id
    ).indexOf('pdf_carta_de_troca');

    if (indexOf > -1) data.current_phase.fields.splice(indexOf, 1);

    hideExchangeLetterPdfHistory(data);
  };

  async function uploadFile(files: any[], fieldId: string, propFiles?: any[]) {
    const fileUrlList: string[] = [];

    if(fieldId == EnumPipefyInputFieldIds.ANEXOS_BOLETIM_OCORRENCIA && propFiles && propFiles.length > 0) {
      propFiles.forEach((file: any) => {
        removeFile(propFiles, file, fieldId);
      });
    }

    for (const index in files) {
      const currentFile = files[index];

      if (currentFile?.type === "") {
        return toast.info('Atenção', 'Adicione uma extensão ao arquivo antes de fazer o upload. Arquivos sem extensão não são permitidos.');
      }

      const result = await _pipefyService.uploadFile(currentFile, setProgress);
      const urlProcessed = urlReplace(result);

      fileUrlList.push(urlProcessed);

      setProgress(0);
    }

    setState((prevState: any) => {
      return {
        ...prevState,
        [fieldId]: fixUrls(
          typeof prevState[fieldId] === "string"
            ? prevState[fieldId] !== ""
              ? [...prevState[fieldId].split(","), ...fileUrlList]
              : fileUrlList
            : [...prevState[fieldId], ...fileUrlList]
        ),
      };
    });

    setLastChangedField({ id: fieldId, value: state[fieldId] });
  }

  async function removeFile(files: any[], file: any, fieldId: string) {
    const oldFiles = files.filter((c) => c.url !== file.url);

    setState(() => {
      setLastChangedField({
        id: fieldId,
        value: fixUrls(oldFiles.map((c) => c.url)),
      });
      return { ...state, [fieldId]: fixUrls(oldFiles.map((c) => c.url)) };
    });
  }

  async function moveCardTo(destinationId: any, phaseName: string) {
    if (!cardNumber) return;

    toast.yesNo(
      `Confirma mover para '${phaseName}'?`,
      () => moveCardToConfirmed(destinationId, phaseName),
      "Sim",
      "Não"
    );
  }

  function errorMoveCard(errorMessage: string = "Não foi possível mover o card. Tente novamente mais tarde!") {
    setIsMovingCard(false);
    setMoveCard(true);
    toast.error(errorMessage);
  }

  function verifyMoveCard(phaseName: string) {
    if (phaseName.toUpperCase() == "EM ANÁLISE PARA PROCESSAMENTO" && ticketCard) {
      const items = ticketCard.order?.items?.filter((item: any) => item.returnQuantity <= 0);
      if (!items || items.length > 0) {
        errorMoveCard(`Desculpe, não podemos avançar o protocolo para esta fase no momento. 
        Parece que não há itens para serem devolvidos. 
        Por favor, verifique se já existe um protocolo de devolução em andamento ou concluído para esse pedido.`);
        return false;
      }
    }
    return true;
  }

  function getResponsibleGroup(result: any) {
    processResponsibleGroup(result);
    return responsibleGroup;
  }

  async function moveCardToConfirmed(destinationId: any, phaseName: string) {
    const data: any = { cardId: cardNumber, destinationPhaseId: destinationId };

    const dataUpdate: any = {
      id: card?.ticketId,
      phaseStatus: phaseName,
      UserWhoUpdatedId: user?.id,
      statusType: getStatusType(phaseName),
      responsibleGroup: undefined,
      cardId: data.cardId
    };

    setIsMovingCard(true);
    setMoveCard(false);

    if (!verifyMoveCard(phaseName)) return;

    await _pipefyService
      .moveCard(data.cardId, data.destinationPhaseId)
      .then(async (resultMoveCard) => {
        await _pipefyService
          .findCard(resultMoveCard.data.moveCardToPhase.card.id)
          .then(async (result) => {
            // primeiramente temos que pegar o id do field do grupo responsável

            let responsibleGroupPipefy = getResponsibleGroup(result) || "";

            if (responsibleGroupPipefy) {
              dataUpdate.responsibleGroup = userProfileTypes
                ? userProfileTypes.find(
                    (item) =>
                      RemoveAccent(item?.value)?.toUpperCase() ===
                      responsibleGroupPipefy.toUpperCase()
                  )?.key
                : card?.responsibleGroup;
            } else {
              dataUpdate.responsibleGroup = card?.responsibleGroup;
            }

            if (!phasesBloquedUpdate.includes(phaseName)) {
              await _ticketService.updateFields(dataUpdate);
            }

            card?.state?.setRefreshTable(true);
            toast.success("Card movido com sucesso!");
            dispatch({ type: "SET_CARD_ID", id: undefined });
          })
          .catch(() => {
            errorMoveCard();
          });
      })
      .catch(() => {
        errorMoveCard();
      });
  }

  const updateField = async () => {
    if (!lastChangedField?.id || state[lastChangedField.id] === sentValues[lastChangedField.id]) {
      return;
    }

    setBlockMoveCardAwaitUpdateField(true);

    await _pipefyService
      .updateCard(
        cardNumber,
        lastChangedField.id,
        state[lastChangedField.id]
      )
      .then(async () => {
        setSentValues((prevState: any) => ({
          ...prevState,
          [lastChangedField.id]: state[lastChangedField.id],
        }));

        setBlockMoveCardAwaitUpdateField(false);

        const reason = form.card.fields.find((x: FieldsCardProps) => x.name === 'Motivo');

        if (form.card.current_phase.name === "Avaliação Qualidade" && reason.value.toUpperCase() === 'ATUALIZAÇÃO DE DOCUMENTOS') {
          updateFieldsUpdateDocument();
        }
      });
  };

  const updateFieldsUpdateDocument = useCallback(() => {
    if (form && state && (!state['status_do_documento'] || state['status_do_documento'] === 'Reprovado') && state['anexo_de_retorno_7']) {
      state['data_de_vig_ncia'] = '';
      state['n_mero_do_documento'] = '';
      state['tipo_do_documento'] = '';

      setState({ ...state });

      setLastChangedField({ id: 'data_de_vig_ncia', value: '' });
      setLastChangedField({ id: 'n_mero_do_documento', value: '' });
      setLastChangedField({ id: 'tipo_do_documento', value: '' });
    }
  }, [form, state]);

  function setBuCardPipefy(fieldBuPipefy: FieldsCurrentPhaseProps) {
    if (!phasesBuCardPipefy.includes(form.card.current_phase.name) || !fieldBuPipefy) {
      return;
    }

    const buSelected = form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === 'bu')?.value;
    const buId = fieldBuPipefy.id;
    const inputBUFormFields = form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === buId)?.value;
    const buCard = fieldBuPipefy.options.find((x: any) => x.includes(buSelected));
    if (!inputBUFormFields) {
      setState({
        ...state,
        [buId]: buCard
      });
      setLastChangedField({
        id: buId,
        value: buCard
      });
    } else if (inputBUFormFields === '') {
      setState({
        ...state,
        [fieldBuPipefy.id]: buCard
      });
      setLastChangedField({
        id: fieldBuPipefy.id,
        value: buCard
      });
    }
  }

  useEffect(() => {
    if (!form || user?.userType !== 'employee') {
      return;
    }

    const findFieldResponsible = form.card.current_phase.fields.find((x: FieldsCurrentPhaseProps) => x.label === 'Responsável pelo Atendimento');
    const findFieldStatusDocument = form.card.fields.find((x: FieldsCardProps) => x.name === 'Status do Documento');
    const findFieldBU = form.card.current_phase.fields.find((x: FieldsCurrentPhaseProps) => x.label === 'BU');

    if (findFieldResponsible) {
      setState({
        ...state,
        [findFieldResponsible.id]: `${user?.username} - ${user?.fullName}`
      });
      setLastChangedField({
        id: findFieldResponsible.id,
        value: `${user?.username} - ${user?.fullName}`
      });
    }

    if (findFieldStatusDocument && form.card.current_phase.name === 'Avaliação Qualidade') {
      setState({
        ...state,
        [findFieldStatusDocument.field.id]: findFieldStatusDocument.value
      });
      setLastChangedField({
        id: findFieldStatusDocument.field.id,
        value: findFieldStatusDocument.value
      });
    }

    setBuCardPipefy(findFieldBU);
  }, [form, user]);

  function downloadLinkUnique(id: string) {
    const field = form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === id);
    const url = field?.value || "";
    const parts = url.split(' | ');

    if (id === EnumPipefyInputFieldIds.PDF_CARTA_TROCA) {
        const fileName = "Carta de Troca";
        return (
            <p className="pp-title-description" key={1}>
                <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    download={fileName}
                >
                    {fileName}
                </a>
            </p>
        );
    }

    if (parts.length < 2) {
        return <p>-</p>;
    }

    const [fullFileName, fileUrl] = parts;

    const fileName = fileUrl ? extractFileName(fileUrl) : fullFileName;

    return (
        <p className="pp-title-description" key={1}>
            <a
                href={fileUrl || fullFileName}
                target="_blank"
                rel="noreferrer"
                download={fileName}
            >
                {fileName}
            </a>
        </p>
    );
}

  function extractFileName(url: string): string {
    const segments = url.split('/');
    return segments.pop() || '';
  }

  async function downloadLink(id: string) {

    const valor = form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === id)?.value || "";
    const files = valor.split(" >");

    return await Promise.all((files as any[]).map(async (item, index) => {

      if (!item) return;

      const uriStorage = item.split(" | ")[1];
      const urlOriginType = uriStorage.includes(PROTHEUS_STORAGE_NAME) ? FileOriginType.PROTHEUS : FileOriginType.CUSTOMER_CARE;

      const urlFile = urlOriginType == FileOriginType.PROTHEUS ? (await _storageFileService.getUrlWithSasToken(uriStorage, urlOriginType)).data.data : uriStorage;

      return (
        <p className="pp-title-description" key={index}>
          <a
            href={urlFile}
            target="_blank"
            rel="noreferrer"
            download
          >
            {item.split(" | ")[0]}
          </a>
        </p>
      );
    }));
  }

  function getInputValueById(id: string) {
    return cleanStr(
      form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === id)?.value || ""
    );
  }

  async function getCategoriesReasons() {
    const options: ICategoriesReasons = await _ticketService.getCategoriesReasons();

    const { data } = options.data;
    if (data) {
      setAllCategories(data.categories);
      setAllReasons(data.reasons);
      setAllClassifications(data.classifications);
    }
  }

  useEffect(() => {
    getCategoriesReasons();
  }, []);

  function setMoveCardDisable(context: string) {
    const isResponsibleGroup = user?.profileType?.some(
      item => item.toLowerCase() === responsibleGroupAux?.toLowerCase()
    );

    const pipefyLinkTypeMember = user?.pipefyLink === PipefyLinkType.NoLink;
    const isCardDone = form.card.done;
    const hasNoPhases = getPhases().length === 0 && getPhases(true).length === 0;
    const isCanMoveCard = availableMoveCardWithPhase();

    if (context === EnumDisableContext.Button) {
      return pipefyLinkTypeMember || !isResponsibleGroup || isCardDone || hasNoPhases || isCanMoveCard;
    } else if (context === EnumDisableContext.Input) {
      return pipefyLinkTypeMember || !isResponsibleGroup || isCardDone || isCanMoveCard;
    }
    return false;
  }

  function availableMoveCardWithPhase() {
    let available = true;
    let currentPhase = form.card.current_phase.name;

    if (!card?.ticketCorrectionLetter) {
      available = false;
    }

    if (currentPhase.toUpperCase() === "PROCESSAMENTO CARTA DE TROCA") {
      available = true;
    }

    if (currentPhase.toUpperCase() === "APROVAÇÃO DE EXTRAVIO") {
      available = true;
    }

    return available;
  }

  const inputsRequiredOnlyStatusApproved = [
    "data_de_vig_ncia",
    "tipo_do_documento",
    "n_mero_do_documento",
    "status_do_documento"
  ];

  function requiredInputVigencyDate(item: FieldsCurrentPhaseProps) {
    const status = state['status_do_documento'];

    if (inputsRequiredOnlyStatusApproved.includes(item.id)) {
      if (item.id === 'status_do_documento') {
        const reason = form.card.fields.find((x: FieldsCardProps) => x.name === 'Motivo');

        if (reason.value.toUpperCase() === 'ATUALIZAÇÃO DE DOCUMENTOS') {
          return true;
        }

        return false;

      } else if (status === 'Aprovado') {
        return true;
      } else {
        return false;
      }
    } else {
      return item.required;
    }
  }

  function requiredInputAttachFile(item: FieldsCurrentPhaseProps) {
    const status = state['classifica_o_do_protocolo_1'];
    if (status === 'Extravio' || status === 'Furto') {
      return item.id === EnumPipefyInputFieldIds.ANEXOS_BOLETIM_OCORRENCIA;
    }

    return false;
  }

  const selectionElementsDisable = [
    "medicamentos_controlados"
  ];

  function conditionDisableSelectionElement(item: FieldsCurrentPhaseProps) {
    const status = state['status_do_documento'];

    if (selectionElementsDisable.includes(item.id)) {
      return status === 'Reprovado';
    }

    return false;
  }

  const conditionDisableInputs = (item: FieldsCurrentPhaseProps) => {
    let currentPhase = form.card.current_phase.name;

    if (currentPhase === "Aprovação de extravio") {
      if (inputsDisableToPhaseApprovalForLoss.includes(item.id))
        return true;
    }

    return false;
  };

  function requiredSelectBrand(item: FieldsCurrentPhaseProps) {
    if (item.id === "marcas") {
      const brandSelectedInitialForm = form.card.fields.find((x: FieldsCardProps) => x.name === "Empresas Viveo");

      if (brandSelectedInitialForm &&
        (brandSelectedInitialForm.value === "Cremer / Embramed" || brandSelectedInitialForm.value === "Cremer / Embramed / Flexicotton")) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  const isInputRequiredOnlyStatusApproved = (id: string, item: FieldsCurrentPhaseProps) => {
    return inputsRequiredOnlyStatusApproved.includes(id) && !requiredInputVigencyDate(item);
  };

  const isFieldDisabledForNonApproving = (item: FieldsCurrentPhaseProps): boolean => {

    const { phases_history } = form.card;
    const currentPhase = form.card.current_phase.name;
    const userEmail = user?.email || '';

    const phaseReverseLogisticsEvaluation = phases_history.find(
      (history: PhasesHistoryProps) => history?.phase?.name === PhasesProtocols.AVALIACAO_LOGISTICA_REVERSA
    );

    if (!phaseReverseLogisticsEvaluation) {
      return false;
    }

    const approvalLabels = [
      PipefyFieldLabelEnum.VALIDADO_GESTOR_COMERCIAL,
      PipefyFieldLabelEnum.VALIDADO_DIRETORIA_COMERCIAL
    ];

    const approvalFieldId = getApprovalFieldId(currentPhase);

    if (approvalFieldId) {
      const phaseFieldData = phaseReverseLogisticsEvaluation.phase.fields.find(
        (field: Field) => field.id === approvalFieldId
      );

      if (phaseFieldData.id !== "") {
        const approverEmail = getInputValueById(phaseFieldData.id)?.split(' - ')[1];

        if (approverEmail && approverEmail !== userEmail) {
          const isFieldApprover = approvalLabels.includes(item.label as PipefyFieldLabelEnum);

          if (isFieldApprover) item.required = false;
          return isFieldApprover || item.label === PipefyFieldLabelEnum.ANEXOS;
        }
      }
    }

    return false;
  };

  function mustInputBeReadOnly(item: FieldsCurrentPhaseProps) {
    const { label, id } = item;

    if (isLabelMinimalReadOnly(label)) {
      return true;
    }

    if (isInputDisableToPhaseApprovalForLoss(id)) {
      return true;
    }

    if (!isManualDevolutionEnterprise(orderEnterpriseCode) && isLabelReadOnly(label)) {
      return true;
    }

    if (isInputRequiredOnlyStatusApproved(id, item)) {
      return true;
    }

    if (isFieldDisabledForNonApproving(item)) {
      return true;
    }

    return false;
  }

  function showField(item: any) {
    if (form.card.current_phase.name === PhasesProtocols.AVALIACAO_QUALIDADE && fieldsToDisableOnQuality.includes(item.id)) {
      return false;
    }

    if (form.card.current_phase.name === PhasesProtocols.RETORNO_DA_QUALIDADE && item.id === PipefyFieldIdsEnum.INFORMAR_NUMERO_PLANO_ACAO) {
      return showActionPlanNumber(item?.id);
    }

    const fieldsByLabelCustomerCanSee = [
      "Status do Protocolo",
      "Resposta ao protocolo",
      "Grupo responsável",
      "Anexo de retorno",
      "Status da Qualidade",
      "Tipo de Recusa Qualidade",
      "Usuário Aprovador",
      "Descrição do usuário sobre a recusa"
    ];

    const showFieldForEmployee = ['Classificação protocolo extravio', 'Anexar arquivo - Boletim de Ocorrência'].includes(item.label)
      ? card?.ticketReason === ReasonNameEnum.FALTA_DE_VOLUME
      : true;

    let show =
      (user?.userType === "employee" && showFieldForEmployee) ||
      (user?.userType !== "employee" && fieldsByLabelCustomerCanSee.includes(item.label));

    return show;
  }

  function setPhaseOrder(phases: any) {
    phases.forEach((elCard: any) => {
      elCard.order = pipePhases.findIndex(
        (elPipe: any) => elPipe.sequentialId === elCard.sequentialId
      );
    });
  }

  const getBrands = async () => {
    const response = await _brandServices.get(undefined, undefined, 'name asc', {
      and: [
        { enable: { eq: true } }, { enterpriseCode: { eq: 999 } }
      ]
    });

    const { data } = response;

    if (data) {
      const _brandOption: Array<IOption> = new Array<IOption>();
      Object.keys(data).forEach((key) => {
        _brandOption.push({
          value: data[key].id,
          label: data[key].name,
          enterpriseCode: parseInt(data[key].enterpriseCode)
        });
      });

      setBrandOption(_brandOption);
    }
  };

  useEffect(() => {
    getBrands();
  }, []);

  function getFieldValue(id: string): string | undefined {
    return sentValues[id] === undefined ? state[id] : sentValues[id];
  };

  function getPhases(past?: boolean) {

    const currentSequentialId = pipePhases.findIndex(
      (elPipe: any) =>
        elPipe.sequentialId === form.card.current_phase.sequentialId
    );

    let newPhases: CurrentPhaseMovedToPhasesProps[] = [];
    let allPhases: CurrentPhaseMovedToPhasesProps[] = form.card.current_phase.cards_can_be_moved_to_phases || [];
    let currentPhase = form.card.current_phase.name;

    const blockedPhases: string[] = getBlockedPhasesByCurrentPhase(currentPhase);

    allPhases = allPhases.filter(phase => !blockedPhases.includes(phase.name));

    const categoryProtocol: FieldsCardProps = form?.card?.fields.find((x: FieldsCardProps) => x.name.toUpperCase() === 'CATEGORIA DO PROTOCOLO');
    const reason: FieldsCardProps = form.card.fields.find((x: FieldsCardProps) => x.name === 'Motivo' && x.field.id === "motivo");

    if (currentPhase.toUpperCase() === "PROTOCOLO CONCLUÍDO" || currentPhase.toUpperCase() === "PROTOCOLO CANCELADO") {
      return newPhases;
    }

    if (card?.ticketReason && !reasonsShowSefaz.includes(card?.ticketReason.toUpperCase())) {
      allPhases = allPhases.filter((x: any) => x.name !== PhasesProtocols.DESABILITAR_MOVE_PARA_SEFAZ);
    }

    setPhaseOrder(allPhases);
    OrderArrayByNumberKey(allPhases, "order");

    let phases: CurrentPhaseMovedToPhasesProps[] = allPhases.filter((phase: any) =>
      past
        ? Number(phase.order) < Number(currentSequentialId)
        : Number(phase.order) > Number(currentSequentialId)
    );

    if (TicketRule.isDevolution(categoryProtocol.value)) { 
        
      if (isAdverseEventAssessment(currentPhase))
        return phases.filter((x: any) => x.name == PhasesProtocols.AVALIACAO_COSMETOVIGILANCIA);   
      
      phases = ruleHidePhaseCancel(phases, currentPhase, categoryProtocol.value, form.card);

      switch (currentPhase) {
        case PhasesProtocols.AVALIACAO_TORRE_CONTROLE:
          return handleTowerControlEvaluation(phases);
        case PhasesProtocols.AVALIACAO_LOGISTICA_REVERSA:
          return handleReverseLogisticsEvaluation(phases);
        default:
          return phases;
      }
    }

    let phasesPossibles: string[] = [];

    if (card?.ticketDevolution) {
      phasesPossibles = ["PROTOCOLO CONCLUÍDO", "EM ANÁLISE PARA PROCESSAMENTO", "PROTOCOLO CANCELADO"];

      phases.forEach((phase: any) => {

        if (currentPhase === PhasesProtocols.AVALIACAO_LOGISTICA_REVERSA) {
          phasesPossibles = phasesPossibles.filter(x => x !== PhasesProtocols.PROTOCOLO_CANCELADO.toUpperCase());
        }

        const phaseExists = phasesPossibles.includes(phase.name.toUpperCase());
        if (phaseExists) {
          newPhases.push(phase);
        }
      });

      return newPhases;
    }

    const enterpriseViveo = form.card.fields.find((x: FieldsCardProps) => x.name === "Empresas Viveo")?.value;
    const indexEnterpriseViveo = brandOption.findIndex(x => enterpriseViveo && x.label.toUpperCase() === enterpriseViveo.toUpperCase());

    if (currentPhase === PhasesProtocols.EM_ANALISE_PARA_PROCESSAMENTO &&
      categoryProtocol.value === CategoryNameEnum.LOGISTICA &&
      reason.value === ReasonNameEnum.FALTA_DE_VOLUME) {
      return getDonePhasesOnly(phases);
    }

    if (indexEnterpriseViveo !== -1) {
      return phases.filter((x: any) => x.name.toUpperCase() !== "LIBERAÇÃO DA DEVOLUÇÃO");
    }

    if (currentPhase.toUpperCase() === 'RETORNO DO SAC' && categoryProtocol.value.toUpperCase() === 'DEVOLUÇÃO') {
      const enterprise: FieldsCardProps = form?.card?.fields.find((x: FieldsCardProps) => x.name.toUpperCase() === 'EMPRESAS VIVEO');

      if (enterprise) {
        const enterprisesLabs = ['BioGenetix', 'Byogene', 'VitaLab'];
        const labsGroup = enterprisesLabs.includes(enterprise.value);

        if (labsGroup) {
          phasesPossibles = ["EM PROCESSO DE COLETA MANUAL",
            "COMPENSAÇÃO DE NOTA DE CRÉDITO MANUAL", "PROTOCOLO CONCLUÍDO",
            "PROTOCOLO CANCELADO"];

          phases.forEach(phase => {
            const phaseExists = phasesPossibles.includes(phase.name.toUpperCase());
            if (phaseExists) {
              newPhases.push(phase);
            }
          });

          return newPhases;
        } else {
          newPhases = phases.filter(x =>
            x.name.toUpperCase() !== "EM PROCESSO DE COLETA MANUAL" &&
            x.name.toUpperCase() !== "COMPENSAÇÃO DE NOTA DE CRÉDITO MANUAL");

          return newPhases;
        }
      }
    }

    if (currentPhase === PhasesProtocols.APROVACAO_DE_DOCUMENTOS) {
      return [];
    }

    if (currentPhase === PhasesProtocols.AVALIACAO_LOGISTICA && reason.value !== ReasonNameEnum.CONFIRMACAO_DE_ENDERECO_ENTREGA) {
      return phases.filter((x: any) => x.name !== PhasesProtocols.AVALIACAO_FISCAL);
    }

    if (currentPhase.toUpperCase() === 'ANÁLISE DO PROTOCOLO' &&
      reason.value.toUpperCase() === 'ATUALIZAÇÃO DE DOCUMENTOS') {
      return phases.filter(phase => 'PROTOCOLO CANCELADO' === phase.name.toUpperCase());
    }

    return phases;
  }

  const isAdverseEventAssessment = (currentPhase: string) => {
    const isQualityPhase = currentPhase === PhasesProtocols.AVALIACAO_QUALIDADE
    const isAdverseEventAssessmentField = form.card.fields.find((x: FieldsCardProps) => x.value === 'SIM' && x.field.id === PipefyFieldIdsEnum.AVALIACAO_DE_EVENTO_ADVERSO);
    const isAdverseEventAssessmentChanged = lastChangedField?.id === PipefyFieldIdsEnum.AVALIACAO_DE_EVENTO_ADVERSO;

    if (isAdverseEventAssessmentChanged) setAdverseEventChecked(lastChangedField?.value);

    const isAdverseEventAssessmentState = !adverseEventChecked ? isAdverseEventAssessmentField : adverseEventChecked === "SIM";
    return isQualityPhase && isAdverseEventAssessmentState;
  }

  const showActionPlanNumber = (idField: string) => {
    const isCauseAnalysisField = form.card.fields.find((x: FieldsCardProps) => x.value === 'SIM' && x.field.id === PipefyFieldIdsEnum.ANALISE_DA_CAUSA);
    const isActionPlanNumber = idField === PipefyFieldIdsEnum.INFORMAR_NUMERO_PLANO_ACAO;
    const isCauseAnalysisChanged = lastChangedField?.id === PipefyFieldIdsEnum.ANALISE_DA_CAUSA;
    const isCauseAnalysisState = (isCauseAnalysisField && !isCauseAnalysisChanged) || (isCauseAnalysisChanged && lastChangedField?.value === "SIM");
    return isCauseAnalysisState && isActionPlanNumber;
  }

  const mustMoveButtonBeDisabled = useMemo(() => {
    const phaseCurrent = form?.card?.current_phase?.name;
    const numberProcess: FieldsCardProps = form?.card?.fields.find((x: FieldsCardProps) => x?.field?.id === PipefyFieldIdsEnum.NUMERO_PD);
    const statusProcess: FieldsCardProps = form?.card?.fields.find((x: FieldsCardProps) => x?.field?.id === PipefyFieldIdsEnum.STATUS_PD);

    const isProcessPending = phaseCurrent === PhasesProtocols.EM_ANALISE_PARA_PROCESSAMENTO &&
      !!numberProcess?.value &&
      statusProcess?.value === 'PENDENTE';

    return isProcessPending;
  }, [form?.card]);

  function getBlockedPhasesByCurrentPhase(currentPhase: string) {
    switch (currentPhase) {
      case PhasesProtocols.COMPENSACAO_NOTA_DE_CREDITO:
        return [PhasesProtocols.APROVACAO_DE_EXTRAVIO];

      default:
        return [];
    }
  }

  function handleTowerControlEvaluation(phases: CurrentPhaseMovedToPhasesProps[]): CurrentPhaseMovedToPhasesProps[] {
    const isPhaseValidPhase = form.card.phases_history.find((history: PhasesHistoryProps) => history.phase?.name === PhasesProtocols.AVALIACAO_LOGISTICA_REVERSA);

    if (isPhaseValidPhase) {
      const typeOfSolution = form.card.fields.find((field: FieldsCardProps) => field.name === "Tipo da Solução")?.value;

      if (typeOfSolution !== "Reentrega") {
        return phases.filter((phase) => phase.name !== PhasesProtocols.PROTOCOLO_CONCLUIDO);
      }
    }

    return phases;
  }

  function handleReverseLogisticsEvaluation(phases: CurrentPhaseMovedToPhasesProps[]): CurrentPhaseMovedToPhasesProps[] {
    const solutionType = getFieldValue(PipefyFieldIdsEnum.TIPO_SOLUCAO_1);
    const commercialDirectorApprover = getFieldValue(PipefyFieldIdsEnum.APROVADOR_DIRETORIA_COMERCIAL);
    const commercialManagerApprover = getFieldValue(PipefyFieldIdsEnum.APROVADOR_GERENCIA_COMERCIAL);
    const commercialManagerApproval = getFieldValueFromHistory(form.card, PipefyFieldIdsEnum.VALIDADO_GESTOR_COMERCIAL);

    if (!commercialDirectorApprover || commercialManagerApproval !== "SIM") {
      phases = phases.filter((phase: CurrentPhaseMovedToPhasesProps) => phase.name.toUpperCase() !== PhasesProtocols.AVALIACAO_DIRETORIA_COMERCIAL.toUpperCase());
    }

    if (!commercialManagerApprover) {
      phases = phases.filter((phase: CurrentPhaseMovedToPhasesProps) => phase.name.toUpperCase() !== PhasesProtocols.AVALIACAO_GERENCIA_COMERCIAL.toUpperCase());
    }

    if (solutionType === "Reentrega") {
      const phasesPossibles = [PhasesProtocols.AVALIACAO_TORRE_CONTROLE, PhasesProtocols.PROTOCOLO_CONCLUIDO];

      return phases.filter((phase: CurrentPhaseMovedToPhasesProps) => phasesPossibles.includes(phase.name as PhasesProtocols));
    }

    if (solutionType === "Improcedente") {
      return phases.filter((phase: CurrentPhaseMovedToPhasesProps) => phase.name.toUpperCase() === PhasesProtocols.PROTOCOLO_CONCLUIDO.toUpperCase());
    }

    return phases;
  }

  useEffect(() => {
    getForm();
  }, [getForm]);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "scroll";
    };
  }, []);

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, "value asc", {
        and: [
          { identifier: { eq: "UserProfileTypes" } },
          { enabled: { eq: true } },
        ],
      })
      .then((result: any) => {
        if (result && result.data) {
          const _userProfileTypes: Array<IDomainSetting> = result.data;

          setUserProfileTypes(_userProfileTypes);
        }
      });
  }, []);

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, "value asc", {
        and: [
          { identifier: { eq: "PhasesBloquedUpdate" } },
          { enabled: { eq: true } },
        ],
      })
      .then((result: any) => {
        if (result && result.data)
          setPhasesBloquedUpdate(result.data[0].value?.split(';'));
      });
  }, []);

  useEffect(() => {
    updateField();
  }, [lastChangedField]);

  const newDescription = (e: any, propsNewDescription: any) => {
    let target = e.target;
    let position = target.selectionStart;

    const newValue = RemoveCharsAccents(e);

    target.setSelectionRange(position, position);
    setState({
      ...state,
      [propsNewDescription.id]: newValue.value,
    });
  };

  const setValueLongText = (propsLongText: any) => {
    if (
      (propsLongText.id === "revis_o_do_texto_da_carta_de_corre_o" ||
        propsLongText.id === "revis_o_do_texto_da_carta_de_corre_o_1") &&
      card?.ticketReason === "CARTA DE CORREÇÃO") {

      return <TextArea
        {...propsLongText}
        onChange={(e) => newDescription(e, propsLongText)}
        className="pp-contenteditable pp-input input-note-correction"
      />;
    } else if ((propsLongText.id === "revis_o_do_texto_da_carta_de_corre_o" ||
      propsLongText.id === "revis_o_do_texto_da_carta_de_corre_o_1") &&
      card?.ticketReason !== "CARTA DE CORREÇÃO") {
      return false;
    }

    return <Textarea {...propsLongText} />;
  };

  const components: any = useMemo(
    () => ({
      time: (propsComponent: any) => {
        return <InputDate type="time" placeholder="00:00" {...propsComponent} />;
      },
      date: (propsComponent: any) => {
        return <InputDate type="date" placeholder="dd/mm/aaaa" {...propsComponent} />;
      },
      due_date: (propsComponent: any) => {
        return <InputDate type="date" placeholder="dd/mm/aaaa" {...propsComponent} />;
      },
      short_text: (propsComponent: any) =>
        propsComponent.disabled ? (
          <p>{cleanStr(propsComponent.value || "")}</p>
        ) : (
          <TextField {...propsComponent} />
        ),
      statement: (propsComponent: any) =>
        propsComponent.disabled ? (
          <p>{cleanStr(propsComponent.value || "")}</p>
        ) : (
          <TextField {...propsComponent} />
        ),
      number: (propsComponent: any) =>
        propsComponent.disabled ? (
          <p>{cleanStr(propsComponent.value || "")}</p>
        ) : (
          <TextField {...propsComponent} />
        ),
      long_text: (propsComponent: any) => setValueLongText(propsComponent),
      cnpj: (propsComponent: any) => <TextField {...propsComponent} />,
      id: () => <p>#{cardNumber}</p>,
      email: (propsComponent: any) => <TextField {...propsComponent} />,
      select: (propsComponent: any) => (
        <Select {...propsComponent}>
          <Option value="" />
          {propsComponent.options ? (
            propsComponent.options.map((option: any, index: number) => (
              <Option key={index} value={option}>
                {option}
              </Option>
            ))
          ) : (
            <Option value={propsComponent.value}>{propsComponent.value}</Option>
          )}
        </Select>
      ),
      label_select: (propsComponent: any) => (
        <Select {...propsComponent}>
          {propsComponent.options ? (
            propsComponent.options.map((option: any, index: number) => (
              <Option key={index} value={option}>
                {option}
              </Option>
            ))
          ) : (
            <Option value={propsComponent.value}>{propsComponent.value}</Option>
          )}
        </Select>
      ),
      radio_vertical: (propsComponent: any) =>
        propsComponent.options ? (
          <Column className="flex-1">
            {propsComponent.options.map((option: any, index: number) => (
              <Radio
                {...propsComponent}
                id={`${propsComponent.id}_${option}`}
                className={`${index > 0 ? "mt-1" : ""}`}
                key={index}
                label={cleanStr(option, true)}
                value={option}
                name={propsComponent.id}
                defaultChecked={
                  state[propsComponent.id]?.toLowerCase() === option?.toLowerCase()
                }
              />
            ))}
          </Column>
        ) : (
          <Radio {...propsComponent} label={cleanStr(propsComponent.value, true)} />
        ),
      radio_horizontal: (propsComponent: any) =>
        propsComponent.options ? (
          <Row className="flex-1">
            {propsComponent.options.map((option: any, index: number) => (
              <Radio
                {...propsComponent}
                id={`${propsComponent.id}_${option}`}
                className={`${index > 0 ? "ml-2" : ""}`}
                key={index}
                label={cleanStr(option, true)}
                value={option}
                name={propsComponent.id}
                checked={propsComponent.value?.toLowerCase() === option?.toLowerCase()}
              />
            ))}
          </Row>
        ) : (
          <Radio {...propsComponent} label={cleanStr(propsComponent.value, true)} />
        ),
      checklist_horizontal: (propsComponent: any) => (
        <Checkbox {...propsComponent} label={cleanStr(propsComponent.value, true)} />
      ),
      checklist_vertical: (propsComponent: any) => (
        <Checkbox {...propsComponent} label={cleanStr(propsComponent.value, true)} />
      ),
      attachment: (propsComponent: any) => {
        const ref = useRef<any>(null);
        let propFiles: any[] = [];

        if (typeof propsComponent.value === "string") {
          if (propsComponent.value === "") {
            propFiles = [];
          } else {
            try {
              propFiles = (JSON.parse(propsComponent.value) as any[]).map((c, index) => {
                const parts = c.split("/");
                return {
                  key: index,
                  url: c,
                  name:
                    parts[parts.length - 1].indexOf("?") !== -1
                      ? parts[parts.length - 1].split("?")[0]
                      : decodeURIComponent(parts[parts.length - 1]).split(
                        "?"
                      )[0],
                };
              });
            } catch (err) {
              propFiles = (propsComponent.value as string).split(",").map((c, index) => {
                const parts = c.trim().split("/");
                const progressStep = parts[0].indexOf("...") !== -1;

                if (progressStep)
                  return {
                    key: index,
                    url: c,
                    progress: progress,
                    name: decodeURIComponent(parts[parts.length - 1]).split("?")[0]
                  };
                return {
                  key: index,
                  url: c,
                  name: decodeURIComponent(parts[parts.length - 1]).split("?")[0]
                };
              });
            }
          }
        } else if (
          typeof propsComponent.value === "object" &&
          Array.isArray(propsComponent.value)
        ) {
          propFiles = (propsComponent.value as string[]).map((c, index) => {
            const parts = c.trim().split("/");
            const progressStep = parts[0].indexOf("...") !== -1;
            if (progressStep)
              return {
                key: index,
                url: c,
                progress: progress,
                name: decodeURIComponent(parts[parts.length - 1]).split("?")[0],
              };
            return {
              key: index,
              url: c,
              name: decodeURIComponent(parts[parts.length - 1]).split("?")[0],
            };
          });
        }

        useEffect(() => {
          if (
            propsComponent?.id !== undefined &&
            propsComponent.id == EnumPipefyInputFieldIds.ANEXOS_BOLETIM_OCORRENCIA
          ) {
            var element = ref?.current.querySelector("input[multiple]");
            element?.removeAttribute("multiple")
          }
        });

        return (
          <div ref={ref}>
            <Attachments
              onDrop={(files: any[]) => uploadFile(files, propsComponent.id, propFiles)}
              className="pp-width-500"
              onRemove={(file: any) => removeFile(propFiles, file, propsComponent.id)}
              simpleField
              simpleFieldPlaceholder="Clique ou arraste seu arquivo aqui para anexar"
              files={propFiles}
              emptyStatePlaceholder="Arraste seu arquivo aqui para anexar"
              dropPlaceholder="Arraste aqui"
              buttonPlaceholder="Arraste aqui"
              readOnly={propsComponent.disabled}
              showButton
              {...propsComponent}
            />
          </div>
        );
      },
    }),
    [progress]
  );

  async function openCardProtocolLinked(id: string) {
    const valueInput =
      form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === id)?.value ||
      "";

    const config: IRequestConfig<ITickets> = {
      url: `${base_url}/ticket?$filter=(protocolNumber%20eq%20${valueInput})`,
      method: MethodsTypes.get,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    };

    const response = await Axios(config);

    const { data } = response.data;

    if (data.length > 0) {
      return store.dispatch({
        type: "OPEN_CARD",
        data: {
          id: data[0].cardId,
          protocolNumber: data[0].protocolNumber,
          responsibleGroup: data[0].responsibleGroup,
          ticketId: data[0].id,
        },
      });
    }
  }

  const setValueBUSelected = useCallback(() => {
    if (!form) {
      return;
    }

    const findFieldBU = form.card.current_phase.fields.find((x: FieldsCurrentPhaseProps) => x.label === 'BU');
    const buSelected = form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === 'bu')?.value;
    const inputBUFormFields = form?.card?.fields?.find((item: FieldsCardProps) => item.field.id === findFieldBU.id)?.value;
    const buCard = findFieldBU.options.find((x: string) => x.includes(buSelected));

    if (inputBUFormFields === '' || !state[findFieldBU.id]) {
      return buCard;
    } else {
      return state[findFieldBU.id];
    }
  }, [state, form]);

  const showValueOfValidator = (item: FieldsCurrentPhaseProps) => {
    if (item?.id === "revis_o_do_texto_da_carta_de_corre_o" || item?.id === "revis_o_do_texto_da_carta_de_corre_o_1") {
      return state[item.id]?.trim();
    }

    return item?.label === "BU" ? setValueBUSelected() : state[item.id];
  };

  const mustInternalCommentBeRequired = (item: any) => {

    if (item.label !== PipefyFieldLabelEnum.COMENTARIO_INTERNO) {
      return false;
    }

    const requiredValidationFields = [
      "validado_diretoria_comercial",
      "validado_gestor_comercial",
      "validado_qualidade"
    ];

    return requiredValidationFields.some(fieldId => {
      const currentField = form?.card?.current_phase?.fields?.find((field: CardFieldsCurrentPhaseProps) => field.id === fieldId);
      if (currentField) {
        const fieldValue = getFieldValue(currentField.id);

        if (fieldValue === "NÃO") {
          return true;
        }
      }
      return false;
    });
  };

  const mustCreditValueBeRequired = (item: FieldsCurrentPhaseProps) => {
    if (item.id === PipefyFieldIdsEnum.VALOR_CREDITO_AO_CLIENTE) {
      const mustBeRequired = getFieldValue(PipefyFieldIdsEnum.ITEM_FRACIONADO) === "SIM";
      return mustBeRequired;
    }

    return false;
  };

  const mustLossClassificationBeRequired = (item: FieldsCurrentPhaseProps) => {
    if (item.id === PipefyFieldIdsEnum.CLASSIFICACAO_EXTRAVIO && card?.ticketReason === ReasonNameEnum.FALTA_DE_VOLUME) {
      return true;
    }

    return false;
  };

  const isFieldRequired = (item: FieldsCurrentPhaseProps) => {
    return (
      requiredInputVigencyDate(item) ||
      requiredSelectBrand(item) ||
      requiredInputAttachFile(item) ||
      mustInternalCommentBeRequired(item) ||
      mustCreditValueBeRequired(item) ||
      mustLossClassificationBeRequired(item)
    );
  };

  const isDisabledInputsCheckListAndRadio = (item: FieldsCurrentPhaseProps) => {
    return (
      setMoveCardDisable(EnumDisableContext.Input) ||
      conditionDisableSelectionElement(item) ||
      conditionDisableInputs(item) ||
      isFieldDisabledForNonApproving(item)
    );
  };

  return (
    <PipefyStyles>
      <Column
        className="pipefy d-flex align-center justify-center pp-max-zindex fixed right-0 left-0 pp-card-overlay"
        style={{ background: "rgba(18, 34, 50, 0.85)" }}
      >
        {form ? (
          <Row
            className={`pp-open-card-content justify-center pp-card-wrapper ${user?.userType === "employee" ? "pp-card-wrapper-full" : ""
              }`}
          >
            <CloseButton
              onClick={() => dispatch({ type: "SET_CARD_ID", id: undefined })}
              style={{
                position: "absolute",
                zIndex: 10,
                ...(user?.userType === "employee"
                  ? { right: 30, top: 20 }
                  : { right: 30, top: 10 }),
              }}
            />

            <History
              protocolNumber={protocolNumber}
              form={form}
              components={components}
              filesMap={filesMap}
              allCategories={allCategories}
              allClassifications={allClassifications}
              allReasons={allReasons}
              userProfileTypes={userProfileTypes}
              getInputValueById={getInputValueById}
              openCardProtocolLinked={openCardProtocolLinked}
              showField={showField}
              downloadLinkUnique={downloadLinkUnique}
            />
            {user?.userType === "employee" && (
              <PhaseForm
                form={form}
                components={components}
                state={state}
                setState={setState}
                moveCard={moveCard}
                blockMoveCardAwaitUpdateField={blockMoveCardAwaitUpdateField || mustMoveButtonBeDisabled}
                setMoveCard={setMoveCard}
                setLastChangedField={setLastChangedField}
                getPhases={getPhases}
                moveCardTo={moveCardTo}
                showField={showField}
                isDisabledInputsCheckListAndRadio={isDisabledInputsCheckListAndRadio}
                isFieldRequired={isFieldRequired}
                showValueOfValidator={showValueOfValidator}
                requiredInputVigencyDate={requiredInputVigencyDate}
                mustInputBeReadOnly={mustInputBeReadOnly}
                setMoveCardDisable={setMoveCardDisable}
                setValueBUSelected={setValueBUSelected}
              />
            )}
          </Row>
        ) : (
          <Spinner className="pp-color-info" />
        )}
      </Column>
      {isMovingCard && (
        <Column className="fixed top-0 bottom-0 right-0 left-0 justify-center align-center bg-modal z-999">
          <Spinner className="pp-color-info" />
        </Column>
      )}
    </PipefyStyles>
  );
};

export default Pipefy;